import { BaseUseCase } from "@domains/useCases/UseCaseBase";
class AmoPlaceTradeUseCase extends BaseUseCase {
    constructor(Repo) {
        super();
        this.Repo = Repo;
    }
    async fetchResult(req) {
        return await this.Repo.placeAmoTradeComm(req);
    }
}
export default AmoPlaceTradeUseCase;
